export const META_CONNECT_CHOICE = {
  business: 'business',
  personal: 'personal',
} as const;

export type MetaConnectChoice = (typeof META_CONNECT_CHOICE)[keyof typeof META_CONNECT_CHOICE];

// Our own support article for connecting a Meta business portfolio does not exist yet;
// link to Meta's own explainer until it does.
export const META_BUSINESS_PORTFOLIO_HELP_URL =
  'https://www.facebook.com/business/help/1710077379203657';
